export class PaymentSuccessController {
  constructor($scope, $rootScope, $route) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.route = $route;

    this.init();
  }

  init() {
    if(this.route.current.params.messages) {
      this.scope.messages = JSON.parse(this.route.current.params.messages);
    }

    this.rootScope.getCurrentUser();
  }
}
